<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-06-12 18:37:02
 * @最后编辑: Betway
 * @最后修改时间: 2022-09-16 17:14:48
 * @FilePath: \mrc-base-frontend\src\components\mrc_ess_multiText.vue
-->
<template>
  <div class="multiText">
    <mrc_ess_input
      :label="label"
      v-if="!isNational"
      :placeholder="placeholder ? placeholder : readonly ? ' ' : label"
      :readonly="readonly"
      :disabled="disabled"
      :background-color="backgroundColor"
      @input="change"
      @blur="blur"
      :rules="rules"
      :error-messages="errorMessages"
      :value="field"
    >
    </mrc_ess_input>
    <!-- 填写多语言输入的公共组件 -->
    <v-menu
      v-model="menu_flag"
      v-else
      transition="slide-x-transition"
      bottom
      right
      nudge-bottom="20"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on }">
        <div
          class="d-flex justify-center align-center"
          style="position: relative"
          v-on="on"
        >
          <mrc_ess_input
            :label="label"
            :placeholder="placeholder ? placeholder : readonly ? ' ' : label"
            :readonly="readonly"
            textarea
            :background-color="backgroundColor"
            :error-messages="errorMessages"
            :value="showText"
          >
            <!-- appendIcon="language" <i class="material-icons">language</i>-->
            <template v-slot:append>
              <mrc_ess_svgIcon
                icon-class="outline-language-24px"
                style="font-size: 24px; z-index: 1; margin-top: 6px"
              />
            </template>
          </mrc_ess_input>
          <!-- <mrc_ess_svgIcon icon-class="outline-language-24px"
                           class="ml-n8"
                           style="font-size: 24px;z-index: 1" /> -->
          <div
            style="
              position: absolute;
              width: 100%;
              height: 100%;
              opacity: 0;
              z-index: 1;
            "
          ></div>
        </div>
      </template>
      <v-form ref="fieldForm">
        <v-card>
          <!-- <v-card-subtitle
            :style="{
              color: $vuetify.theme.defaults.light.primary,
              textAlign: 'left',
            }"
          >
            {{ label }}
          </v-card-subtitle> -->
          <v-card-text>
            <!-- 循环多个语言 -->
            <!-- (v) => !characterrules.test(v) || $t('verify_You_cannot_enter_illegal_characters'), -->
            <v-list dense style="max-height: 250px; overflow-y: auto">
              <v-list-item
                class="pa-0"
                v-for="(item, index) in manyLanguage"
                :key="index"
              >
                <mrc_ess_input
                  :readonly="readonly"
                  @keydown="keydown"
                  v-model="item[lang[index]]"
                  textarea
                  placeholder=" "
                  :rules="[
                    noRequired ? true : (v) => !!v || $t('verify_Required'),
                    (v) => !/^ +| +$/g.test(v) || $t('message_No_spaces'),
                    characterrules === false
                      ? true
                      : (v) =>
                          !characterrules.test(v) ||
                          $t('verify_You_cannot_enter_illegal_characters'),
                  ]"
                  :label="
                    langLabel[index] +
                    (defaultLang == lang[index]
                      ? '（' +
                        $t('label_defaultLanguage') +
                        '）' +
                        (noRequired ? '' : '*')
                      : noRequired
                      ? ''
                      : '*')
                  "
                ></mrc_ess_input>
              </v-list-item>
            </v-list>

            <mrc_ess_submitBtn
              v-if="!readonly"
              @cancel="saveCancel"
              backgroundColor="#FFFFFF"
              class="submitBtn mt-n2"
              style="height: auto; justify-content: flex-end"
              @success="saveLanguage"
            ></mrc_ess_submitBtn>
          </v-card-text>
          <!-- <v-card-actions
            class="d-flex justify-end pa-0"
            style="background-color:rgb(224, 224, 224)"
          >
            
          </v-card-actions> -->
        </v-card>
      </v-form>
    </v-menu>
  </div>
</template>

<script>
/**
 * @description: 多语言输入框
 * @param {errorMessages} 校验的错误提示信息
 * @param {readonly} 禁止输入
 * @param {label}  标题
 * @param {placeholder}  占位符
 * @param {isNational}  是否国际化
 * @param {field}  传入参数 国际化就是个数组 非国际化就是个字符串
 * @return:
 * @author: lwq
 */
export default {
  components: {},
  props: {
    noRequired: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
    },
    rules: {
      type: Array,
    },
    characterrules: {
      // default: () => /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im
      default: false,
    },
    errorMessages: {
      type: Array,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
    },
    isNational: {
      type: Boolean,
      default: false,
    },
    field: {
      type: [String, Number, Array],
      required: true,
      default: "",
    },
    backgroundColor: {
      type: String,
    },
  },
  data() {
    return {
      rowsHeight: [],
      menu_flag: false,
      manyLanguage: [],
      tempManyLanguage: [],
    };
  },
  model: {
    prop: "field",
    event: "change",
  },
  computed: {
    // characterrules () {
    //   return /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im
    // },
    currentCompanyLanguage() {
      return this.$store.state.currentCompanyLanguage;
    },
    // 语言列表
    lang() {
      let langArr = [];
      this.currentCompanyLanguage.forEach((item) => {
        langArr.push(item.value);
      });
      return langArr;
    },
    // 多语言对应的label
    langLabel() {
      let langArr = [];
      this.currentCompanyLanguage.forEach((j) => {
        langArr.push(j.text);
      });
      return langArr;
    },
    // 当前语言
    defaultLang() {
      return this.$store.state.lang;
    },
    // 当前语言在返回的列表第几个
    defaultLangIndex() {
      const index = this.lang.indexOf(this.defaultLang);
      return index <= -1 ? 0 : index;
    },
    // 多语言输入框组件外显示的内容
    showText() {
      if (typeof this.field == "string" && this.isNational) {
        return "";
      }
      if (
        Array.isArray(this.field) &&
        this.field.length > 0 &&
        this.isNational
      ) {
        const index = this.field.findIndex((item) =>
          Object.keys(item).includes(this.defaultLang)
        );
        return index != -1 ? this.field[index][this.defaultLang] : "";
        // console.log(this.tempManyLanguage)
        // console.log(this.manyLanguage)
        // console.log(this.field)
        // console.log(this.defaultLangIndex)
        // console.log(this.defaultLang)

        // if (this.field[this.defaultLangIndex][this.defaultLang]) {
        //   return this.field[this.defaultLangIndex][this.defaultLang]
        // }
        // if (this.tempManyLanguage.length > 0) {
        //   return this.tempManyLanguage[this.defaultLangIndex][this.defaultLang]
        // }
        // if (this.manyLanguage.length > 0) {
        //   return this.manyLanguage[this.defaultLangIndex][this.defaultLang]
        // }
        // return this.field[this.defaultLangIndex][this.defaultLang]
      }

      return "";
    },
  },
  watch: {
    field(val) {
      if (Array.isArray(val) && val.length > 0) {
        // 如果manyLanguage没有数据就重传过来的拿，如果是修改过程中有的那就用自带的   这是有值传过来的情况
        // 多选框的列表是所属公司的列表，把传过来的参数和列表参数做比较 ，把传的语言放到对应列表的语言里面
        if (this.manyLanguage.length <= 0) {
          // this.manyLanguage = this.$clone(val)
          this.manyLanguage = this.currentCompanyLanguage.map((item) => {
            const key = item.value;
            item = {};
            item[key] = "";
            this.$clone(val).forEach((fieldItem) => {
              for (var i in fieldItem) {
                if (i == key) {
                  item = fieldItem;
                }
              }
            });

            return item;
          });
        }
        // console.log(this.manyLanguage);
      }
      if (
        (this.isNational && typeof val == "string") ||
        (Array.isArray(val) && val.length <= 0)
      ) {
        // 如果manyLanguage没有数据就重传过来的拿，如果是修改过程中有的那就用自带的  这是没有值传过来的情况
        if (!this.hasVal(this.manyLanguage)) {
          this.manyLanguage = this.currentCompanyLanguage.map((item) => {
            const key = item.value;
            item = {};
            item[key] = "";
            return item;
          });
        }
      }
    },
    menu_flag(val) {
      if (Array.isArray(this.field) && this.field.length > 0 && val) {
        // 如果manyLanguage没有数据就重传过来的拿，如果是修改过程中有的那就用自带的   这是有值传过来的情况
        // 多选框的列表是所属公司的列表，把传过来的参数和列表参数做比较 ，把传的语言放到对应列表的语言里面
        // console.log(this.manyLanguage)
        if (this.manyLanguage.length <= 0) {
          // this.manyLanguage = this.$clone(this.field)
          this.manyLanguage = this.currentCompanyLanguage.map((item) => {
            const key = item.value;
            item = {};
            item[key] = "";
            Array.isArray(this.field) &&
              this.$clone(this.field).forEach((fieldItem) => {
                for (var i in fieldItem) {
                  if (i == key) {
                    item = fieldItem;
                  }
                }
              });

            return item;
          });
        }
        // console.log(this.manyLanguage);
      }
      if (
        (this.isNational && typeof this.field == "string") ||
        (Array.isArray(this.field) && this.field.length <= 0 && val)
      ) {
        // 如果manyLanguage没有数据就重传过来的拿，如果是修改过程中有的那就用自带的  这是没有值传过来的情况
        if (!this.hasVal(this.manyLanguage)) {
          this.manyLanguage = this.currentCompanyLanguage.map((item) => {
            const key = item.value;
            item = {};
            item[key] = "";
            return item;
          });
        }
      }
    },
  },
  created() {},
  mounted() {
    // 这是新增的情况
    if (this.isNational) {
      this.manyLanguage = this.currentCompanyLanguage.map((item) => {
        const key = item.value;
        item = {};
        item[key] = "";
        Array.isArray(this.field) &&
          Array.isArray(this.field) &&
          this.$clone(this.field).forEach((fieldItem) => {
            for (var i in fieldItem) {
              if (i == key) {
                item = fieldItem;
              }
            }
          });
        return item;
      });
    }
  },
  methods: {
    blur(val) {
      this.$emit("blur", val);
    },
    hasVal(arr) {
      let hasValue = false;
      arr.forEach((item) => {
        for (var i in item) {
          if (item[i]) {
            hasValue = Boolean(item[i]);
          }
        }
      });
      return hasValue;
    },
    change(val) {
      this.$emit("change", val);
    },
    keydown(e) {
      if (e.keyCode == 13 && e.ctrlKey) {
        // e.target.style.height += e.target.style.height
        // e.target.value += '\n' //换行
      } else if (e.keyCode == 13) {
        e.preventDefault(); //禁止回车的默认换行
        this.saveLanguage();
      }
    },
    saveLanguage() {
      const submit = this.$refs.fieldForm.validate();
      if (!submit) return;
      this.$emit("change", this.manyLanguage);
      this.tempManyLanguage = this.$clone(this.manyLanguage);
      this.manyLanguage = [];
      this.menu_flag = false;
    },
    saveCancel() {
      this.$refs.fieldForm.reset();
      this.menu_flag = false;
      this.manyLanguage = [];
      this.tempManyLanguage = this.currentCompanyLanguage.map((item) => {
        const key = item.value;
        item = {};
        item[key] = "";
        Array.isArray(this.field) &&
          this.$clone(this.field).forEach((fieldItem) => {
            for (var i in fieldItem) {
              if (i == key) {
                item = fieldItem;
              }
            }
          });

        return item;
      });
      // console.log(this.manyLanguage)
      // console.log(this.field)
    },
  },
};
</script>

<style scoped>
.submitBtn /deep/ .cencelBtn {
  margin-right: 0;
}
</style>
